import React, {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import PageHeader from "../components/PageHeader";
import {useSelector} from "react-redux";
import {apiGetTurnstileTemplate, apiPostTurnstileTemplate} from "./Actions";
import Toast from "cogo-toast";
import {DefaultLoader} from "../../../components/DefaultLoader";
import InputField from "../../../FinalForm/InputField";
import SelectField from "../../../FinalForm/SelectField";
import SwitchField from "../../../FinalForm/SwitchField";
import {getTurnstileTypesToSelect} from "../enigooTurnstileHelper";
import {Form} from "react-final-form";
import arrayMutators from "final-form-arrays";
import {FiSave} from "react-icons/fi";
import {FilterButton} from "../components/Button";
import {FormCard} from "../components/FormCard";

const TurnstileTemplateForm = () => {
    let [loading, setLoading] = useState(false);
    let [saving, setSaving] = useState(false);
    let [data, setData] = useState(null);

    const {id} = useParams();
    const navigate = useNavigate();
    let user = useSelector((state) => state.user);

    useEffect(() => {
        user.activeAreal && getData();
    }, [user.activeAreal]);

    const handleError = (err) => {
        let error = "Nepodařilo se načíst data o šabloně turniketu.\n";
        switch (err.data) {
            case "TURNSTILE_TEMPLATE_NOT_FOUND": error += "Turniket nebyl nalezen."; break;
            case "UNKNOWN_ERROR":
            default:
                if (error.startsWith("TARIFF_")) error += "Neznámý tarif";
                else error += "Neznámá chyba.";
        }
        Toast.error(error);
    };

    const getData = () => {
        if (id) {
            setLoading(true);
            apiGetTurnstileTemplate(user.activeAreal.id, id, (data) => {
                setData({...data});
                setLoading(false);
            }, (err) => {
                setLoading(false);
                handleError(err);
                navigate("/turnstile/template");
            });
        }
    };

    const onSubmit = (values) => {
        if (!user?.user?.rights?.enigooTurniketsEdit) return;
        setSaving(true);
        let newValues = values;
        if (id) newValues = {...values, turnstileTemplateId: id};
        apiPostTurnstileTemplate(user.activeAreal.id, newValues, (data) => {
            setData({...data});
            setSaving(false);
            navigate("/turnstile/template/detail/" + data.id);
            Toast.success("Úspěšně uloženo.");
        }, (err) => {
            setSaving(false);
            handleError(err);
        });
    };

    const _renderTelpoData = () => (
        <>
            <SwitchField name={"data.qrEnabled"}      label={"Čtení QR kódů"}                                              isMandatory={true}/>
            <SwitchField name={"data.nfcEnabled"}     label={"Čtení NFC čipů"}                                             isMandatory={true}/>
            <SwitchField name={"data.confirmPassage"} label={"Potvrzovat průchod na api (čekat na protočení turniketu)"}   isMandatory={true}/>
            <InputField  name={"data.passageInterval"} label={"Čas otevření (s)"} inputType={"number"} isMandatory={false}/>
            <SwitchField name={"data.showMenu"}       label={"Zobrazit menu"}                                              isMandatory={true}/>
            <SwitchField name={"data.showStatusBar"}  label={"Zobrazit status bar"}                                        isMandatory={true}/>
            <InputField  name={"data.baudRateControlBoard"} label={"Baud rate pro spojení se základní deskou"} inputType={"number"} isMandatory={false}/>
        </>
    );

    const _renderVguangData = () => (
        <>
            <SwitchField name={"data.deleteZeroPrefixFromNfc"} label={"Odstraňovat prefix 0 z kódu NFC"} isMandatory={true}/>
            <SwitchField name={"data.nfcToUpperCase"}          label={"NFC kód na velká písmena"}         isMandatory={true}/>
        </>
    );

    const _renderFaceRecognitionData = () => (
        <>
            <InputField name={"data.threshold"} label={"Práh rozpoznávání (-1.0 – 1.0) hodnota -1.0 - projde všechno"} inputType={"number"} isMandatory={true}/>
        </>
    );

    return (
        <>
            <PageHeader crumbs={[{label:"Šablony turniketů", to:"/turnstile/template"}, {label: id ? "Upravit šablonu turniketu" : "Vytvořit šablonu turniketu"}]}/>

            {loading ? <DefaultLoader text={"Načítám data šablony..."}/> : (
                <Form onSubmit={onSubmit} initialValues={data}
                      validate={values => {
                          let errors = {};
                          if(values.type && values.type === 7){
                              if(values?.data?.threshold && (values.data.threshold > 1.0 || values.data.threshold < -1.0)){
                                  errors.data = errors.data || {};
                                  errors.data.threshold = "Zadejte hodnotu od -1.0 do 1.0"
                              }
                          }
                          return errors;
                      }}
                    mutators={{...arrayMutators}}
                    render={({handleSubmit, values}) => (
                        <>
                            <FormCard>
                                <InputField name={"name"} label={"Název"} isMandatory={true} inputType={"text"}/>
                                <SelectField name={"type"} label={"Typ"} isMandatory={true} options={getTurnstileTypesToSelect()}/>
                                {values.type === 4 ? _renderTelpoData() : <></>}
                                {values.type === 0 ? _renderVguangData() : <></>}
                                {values.type === 7 ? _renderFaceRecognitionData() : <></>}
                            </FormCard>
                            {user?.user?.rights?.enigooTurniketsEdit && (
                                <FilterButton type="button" onClick={handleSubmit} loading={saving} text="Uložit" icon={<FiSave size={12}/>} fullWidth/>
                            )}
                        </>
                    )}
                />
            )}
        </>
    );
};
export default TurnstileTemplateForm;
